module.exports = __webpack_public_path__ + "img/sports.49e1e3bd.png";